import { BaseNetworkLog } from './base-network-log';
import { NetworkLogStatus, type NetworkRequestData } from '../types';
import type { InitNetworkLog } from './init-network-log';

export class PendingNetworkLog extends BaseNetworkLog {
  public status = NetworkLogStatus.PENDING as const;

  public request: NetworkRequestData;

  constructor(initNetworkLog: InitNetworkLog, requestData: NetworkRequestData) {
    super(initNetworkLog.id);
    this.request = requestData;
  }
}
